import { API } from '../main'
const prefix = '/workTable'

const createTransportAccounting = (data) => {
    return API(localStorage.getItem('userToken')).post(`${prefix}/transportAccounting`, data)
}

const getTransportAccounting = (role) => {
    return API(localStorage.getItem('userToken')).get(`${prefix}/transportAccounting/${role}`)
}

const updateTransportAccounting = (data) => {
    return API(localStorage.getItem('userToken')).patch(`${prefix}/transportAccounting`, data)
}

export { createTransportAccounting, getTransportAccounting, updateTransportAccounting }